<!-- 팝업은 하나만 보임 -->
<template>
	<div class="popup_container">
		<div ref="popupRef" class="popup_box">
			<div v-if="loginPopupStore.popup.icon" class="popup_icon">
				<svg
					v-if="loginPopupStore.popup.icon === 'alert'"
					width="120"
					height="120"
					viewBox="0 0 120 120"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_13376_29116)">
						<path
							d="M67 107C92.4051 107 113 86.4051 113 61C113 35.5949 92.4051 15 67 15C41.5949 15 21 35.5949 21 61C21 86.4051 41.5949 107 67 107Z"
							fill="#818393"
						/>
						<g filter="url(#filter0_bd_13376_29116)">
							<path
								d="M53 106.987C78.4051 106.987 99 86.3924 99 60.9873C99 35.5822 78.4051 14.9873 53 14.9873C27.5949 14.9873 7 35.5822 7 60.9873C7 86.3924 27.5949 106.987 53 106.987Z"
								fill="#F7F9FF"
								fill-opacity="0.4"
								shape-rendering="crispEdges"
							/>
							<path
								d="M98.5 60.9873C98.5 86.1163 78.129 106.487 53 106.487C27.871 106.487 7.5 86.1163 7.5 60.9873C7.5 35.8583 27.871 15.4873 53 15.4873C78.129 15.4873 98.5 35.8583 98.5 60.9873Z"
								stroke="url(#paint0_linear_13376_29116)"
								shape-rendering="crispEdges"
							/>
						</g>
						<rect x="48" y="38" width="8" height="34" rx="4" fill="white" />
						<path
							d="M52.0258 83.5361C49.8065 83.5361 48 81.7297 48 79.5103C48 77.3426 49.8065 75.5361 52.0258 75.5361C54.1419 75.5361 56 77.3426 56 79.5103C56 81.7297 54.1419 83.5361 52.0258 83.5361Z"
							fill="white"
						/>
					</g>
					<defs>
						<filter
							id="filter0_bd_13376_29116"
							x="-1"
							y="6.9873"
							width="112"
							height="112"
							filterUnits="userSpaceOnUse"
							color-interpolation-filters="sRGB"
						>
							<feFlood flood-opacity="0" result="BackgroundImageFix" />
							<feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
							<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_13376_29116" />
							<feColorMatrix
								in="SourceAlpha"
								type="matrix"
								values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								result="hardAlpha"
							/>
							<feOffset dx="2" dy="2" />
							<feGaussianBlur stdDeviation="5" />
							<feComposite in2="hardAlpha" operator="out" />
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
							<feBlend mode="normal" in2="effect1_backgroundBlur_13376_29116" result="effect2_dropShadow_13376_29116" />
							<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_13376_29116" result="shape" />
						</filter>
						<linearGradient
							id="paint0_linear_13376_29116"
							x1="53"
							y1="14.9873"
							x2="53"
							y2="106.987"
							gradientUnits="userSpaceOnUse"
						>
							<stop stop-color="white" />
							<stop offset="1" stop-color="white" stop-opacity="0.3" />
						</linearGradient>
						<clipPath id="clip0_13376_29116">
							<rect width="120" height="120" fill="white" />
						</clipPath>
					</defs>
				</svg>

				<svg
					v-else-if="loginPopupStore.popup.icon === 'confirm'"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 15 14"
					fill="#3870ff"
				>
					<path
						d="M7.5 13.6896C3.81 13.6896 0.809998 10.6896 0.809998 6.99957C0.809998 3.30957 3.81 0.30957 7.5 0.30957C11.19 0.30957 14.19 3.30957 14.19 6.99957C14.19 10.6896 11.19 13.6896 7.5 13.6896ZM7.5 1.52957C4.48 1.52957 2.03 3.98957 2.03 6.99957C2.03 10.0096 4.49 12.4696 7.5 12.4696C10.51 12.4696 12.97 10.0096 12.97 6.99957C12.97 3.98957 10.51 1.52957 7.5 1.52957Z"
					/>
					<path
						d="M7.44999 8.21937C7.19999 8.21937 6.96 8.05937 6.87 7.79937C6.76 7.47937 6.94 7.13937 7.25 7.02937C7.61 6.90937 8.66 6.40937 8.66 5.77937C8.66 5.48937 8.56 5.20937 8.37 4.98937C8.19 4.76937 7.93 4.61937 7.64 4.56937C7.36 4.51937 7.07 4.56937 6.82 4.71937C6.57 4.86937 6.38 5.08937 6.29 5.35937C6.18 5.67937 5.83 5.83937 5.51 5.72937C5.19 5.61937 5.03 5.26937 5.14 4.94937C5.33 4.40937 5.70999 3.94937 6.19999 3.65937C6.69999 3.36937 7.27999 3.25937 7.83999 3.35937C8.40999 3.45937 8.92 3.74937 9.29 4.18937C9.66 4.62937 9.86 5.18937 9.86 5.75937C9.86 7.36937 7.85 8.07937 7.62 8.15937C7.56 8.17937 7.49 8.18937 7.43 8.18937L7.44999 8.21937Z"
					/>
					<path
						d="M7.51 10.6497C7.17 10.6497 6.9 10.3797 6.9 10.0397C6.9 9.69969 7.17 9.42969 7.51 9.42969C7.85 9.42969 8.12 9.69969 8.12 10.0397C8.12 10.3797 7.85 10.6497 7.51 10.6497Z"
					/>
				</svg>
				<img v-else :src="loginPopupStore.popup.icon" alt="icon" loading="lazy" />
			</div>
			<div class="popup_content">
				<p
					v-dompurify-html="loginPopupStore.popup.content"
					class="content c_editorContent"
					:class="[{ withSubtext: loginPopupStore.popup.subtext }]"
				></p>
				<p
					v-if="loginPopupStore.popup.subtext"
					v-dompurify-html="loginPopupStore.popup.subtext"
					class="subtext c_editorContent"
				></p>
			</div>

			<div class="popup_action">
				<template v-if="loginPopupStore.popup.confirm">
					<button
						class="c_button dark"
						:class="loginPopupStore.popup.noCancelBtn && 'display-none'"
						@click="onCancelClick"
					>
						{{ loginPopupStore.popup.cancelText ?? '취소' }}
					</button>
					<button ref="btnConfirmRef" class="c_button primary-fill" @click="onConfirmClick" @touchend="onConfirmClick">
						{{ loginPopupStore.popup.confirmText ?? '확인' }}
					</button>
				</template>

				<button v-else ref="btnCloseRef" class="c_button primary-fill" @click="onCancelClick">
					{{ loginPopupStore.popup.cancelText ?? '확인' }}
				</button>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
// core
import { onMounted, onUnmounted, ref, watch } from 'vue';
// router
import { useRoute } from 'vue-router';
// vueuse
import { onClickOutside } from '@vueuse/core';

// store
import { useLoginPopupStore } from '@/stores/LoginPopup';
import { handleLinkClick } from '@/utils/directive/editorLinkOpenNewTab';

const route = useRoute();
const loginPopupStore = useLoginPopupStore();
const popupRef = ref();
const btnConfirmRef = ref();
const btnCloseRef = ref();
const beforeFocusedRef = ref();
const timeId = ref();

onMounted(() => {
	// 원래 포커스 되어있던 요소 저장하고 팝업 버튼에 포커스
	beforeFocusedRef.value = document.activeElement;
	if (btnConfirmRef.value) {
		btnConfirmRef.value.focus();
	} else if (btnCloseRef.value) {
		btnCloseRef.value.focus();
	}

	// showTime 있으면 자동으로 해당 초 이후에 닫히도록
	if (loginPopupStore.popup.showTime) {
		timeId.value = setTimeout(() => {
			loginPopupStore.closePopup();
		}, loginPopupStore.popup.showTime);
	}
});
onUnmounted(() => {
	clearTimeout(timeId.value);
	document.body.classList.remove('hidden');
	// 원래 포커스 되어있던 요소에 다시 포커스
	if (beforeFocusedRef.value) {
		beforeFocusedRef.value.focus();
	}
});
watch(
	// 팝업 중간에 또 열릴경우 showTime 초기화
	() => loginPopupStore.popup,
	() => {
		clearTimeout(timeId.value);
		if (loginPopupStore.popup.showTime) {
			timeId.value = setTimeout(() => {
				loginPopupStore.closePopup();
			}, loginPopupStore.popup.showTime);
		}
	}
);
watch(
	// isRouteConsist가 아니면 라우트 이동시 닫기
	() => route.path,
	() => {
		if (!loginPopupStore.popup.isRouteConsist) {
			loginPopupStore.closePopup();
		}
	}
);

//editor 링크 클릭 시 새창 열기
// COMMENT : AOS에서는 target: _blank로 새창을 띄울 수 없어 추가된 코드입니다.
const contentBody = ref<HTMLDivElement | null>(null);
watch(
	[loginPopupStore.popup],
	() => {
		contentBody.value = document.querySelector('.c_editorContent');

		if (contentBody.value) {
			// 기존 리스너 제거
			contentBody.value.removeEventListener('click', handleLinkClick);

			// 새로운 리스너 추가
			contentBody.value.addEventListener('click', handleLinkClick);
		}
	},
	{ immediate: true }
);

const onConfirmClick = () => {
	if (loginPopupStore.popup.confirm) {
		loginPopupStore.popup.confirm();
	}
	loginPopupStore.closePopup(); // 순서 중요. 마지막에 닫을것. 팝업 닫힌 이후에 또 팝업이 필요하면 props로 넘길 confirm 함수에 setTimeout 주면 됨
};
const onCancelClick = () => {
	if (loginPopupStore.popup.cancel) {
		loginPopupStore.popup.cancel();
	}
	loginPopupStore.closePopup(); // 순서 중요. 마지막에 닫을것. 팝업 닫힌 이후에 또 팝업이 필요하면 props로 넘길 cancel 함수에 setTimeout 주면 됨
};

//모달 외부 클릭시 모달 닫기
onClickOutside(popupRef, () => {
	loginPopupStore.closePopup();
});
</script>

<style scoped lang="scss">
.popup_container {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100vh;
	background: #00000070;
	.popup_box {
		position: relative;
		width: 100%;
		max-width: min(calc(100vw - 4rem), 50rem); /* 20rem 이거나 최소한 양쪽에 2rem의 여백은 갖도록 */
		border-radius: 1rem;
		background-color: var(--color-bg-mid);
		box-shadow: 0rem 0.4rem 0.4rem 0rem rgba(0, 0, 0, 0.25);
		padding: 2.8rem 2rem 2rem 2rem;
		color: #e8eaed;
		text-align: center;
		.popup_icon {
			margin: 0 auto 1.6rem;
		}
		.popup_content {
			display: flex;
			flex-direction: column;
			max-height: 50vh;
			overflow: hidden;
			overflow-y: auto;
			padding: 1px var(--space-large); /* 위아래 1px 안하면 크롬 버그로 overflow됨, 양옆은 스크롤바 끝으로 옮기려고 설정 */
			margin: -1px calc(var(--space-large) * -1);
			gap: 0.4rem;
			white-space: pre-line;
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			line-height: 2.3rem;

			.content {
				letter-spacing: -0.5%;
			}
			.subtext {
				color: var(--color-base-light);
				letter-spacing: 2%;
			}
			.withSubtext {
				font-size: var(--font-s-large);
				font-weight: var(--font-w-semi-bold);
			}
		}
		.popup_action {
			display: flex;
			justify-content: end;
			gap: var(--space-small);
			margin-top: 3.2rem;
			font-size: var(--font-size-small);

			button {
				border-radius: var(--border-radius-xx-small);
				padding: 1.2rem 2.4rem;
				width: 7.3rem;
				height: 5.2rem;
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-semi-bold);
				line-height: 1.7rem;
				flex-grow: 1;
			}

			.display-none {
				display: none;
			}
		}
	}
}
</style>
